import { memo } from 'react'
import { isEqual } from 'lodash'
import RoleManagementContainer from 'app/containers/RoleManagement'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const RoleManagementCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.role_management)}</PageTitle>
      <RoleManagementContainer />
    </>
  )
}
export const RoleManagementPage = memo(RoleManagementCpn, isEqual)
